var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("c-tab", {
        ref: "hazopActionTab",
        attrs: {
          type: "vertical",
          tabItems: _vm.tabItems,
          height: _vm.tabHeight,
        },
        on: {
          "update:height": function ($event) {
            _vm.tabHeight = $event
          },
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (tab) {
              return [
                _c(tab.component, {
                  key: tab.key,
                  tag: "component",
                  attrs: {
                    popupParam: _vm.popupParam,
                    traningEdu: _vm.traningEdu,
                    attachTrainingPictureInfo: _vm.attachTrainingPictureInfo,
                    attachEduPictureInfo: _vm.attachEduPictureInfo,
                    isOld: _vm.isOld,
                    disabled: _vm.disabled,
                    contentHeight: _vm.contentHeight,
                  },
                  on: {
                    "update:popupParam": function ($event) {
                      _vm.popupParam = $event
                    },
                    "update:popup-param": function ($event) {
                      _vm.popupParam = $event
                    },
                    "update:traningEdu": function ($event) {
                      _vm.traningEdu = $event
                    },
                    "update:traning-edu": function ($event) {
                      _vm.traningEdu = $event
                    },
                    "update:attachTrainingPictureInfo": function ($event) {
                      _vm.attachTrainingPictureInfo = $event
                    },
                    "update:attach-training-picture-info": function ($event) {
                      _vm.attachTrainingPictureInfo = $event
                    },
                    "update:attachEduPictureInfo": function ($event) {
                      _vm.attachEduPictureInfo = $event
                    },
                    "update:attach-edu-picture-info": function ($event) {
                      _vm.attachEduPictureInfo = $event
                    },
                    "update:contentHeight": function ($event) {
                      _vm.contentHeight = $event
                    },
                    "update:content-height": function ($event) {
                      _vm.contentHeight = $event
                    },
                    getDetail: _vm.getDetail,
                  },
                }),
              ]
            },
          },
        ]),
        model: {
          value: _vm.tab,
          callback: function ($$v) {
            _vm.tab = $$v
          },
          expression: "tab",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }